const tryParseJSON = (text: string) => {
  try {
    return JSON.parse(text)
  } catch (e) {
    return undefined
  }
}

export default tryParseJSON
